module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm.id,
      "title": _vm.title,
      "hide-footer": ""
    },
    on: {
      "show": _vm.getPayaUrl
    },
    model: {
      value: (_vm.inputVal),
      callback: function($$v) {
        _vm.inputVal = $$v
      },
      expression: "inputVal"
    }
  }, [_c('paya-payment-account', {
    on: {
      "card-added": _vm.cardAdded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2703a14b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/NewPayaPaymentAccountModal.vue
// module id = 1312
// module chunks = 16